
import {
  AbstractAuthorizationSelectionForm,
  ChangedItem
} from '@/app/platform/platform-management/user-group-block/containers/user-group-linked-app-authorizations-editor/abstract-authorization-selection-form';
import { cloneDeep } from 'lodash-es';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';

export class NavigationItemAuthorizationSelectionForm extends AbstractAuthorizationSelectionForm<NavigationItemEntity> {
  init(egiApp: EgiAppEntity, userGroup: UserGroupEntity) {
    super.init(egiApp, userGroup);
    if (egiApp.isNotDefault) {
      const { rootNavigationItem } = this.egiApp;
      const navigationItemsFlattened = rootNavigationItem.asArray;

      const authorizedNavigationItemIds = navigationItemsFlattened
        .filter(i => this.userGroup.hasAccessTo(i))
        .map(i => i.id);

      this.selectionForm.init(...authorizedNavigationItemIds);
    }
  }

  isSelected = (item: NavigationItemEntity): boolean => {
    return this.selectionForm.isSelected(item.id);
  }

  toggle(item: NavigationItemEntity): boolean {
    this.selectionForm.toggle(item.id);
    const isNowSelected = this.selectionForm.isSelected(item.id);
    if (isNowSelected) {
      this.selectAncestors(item);
    } else {
      this.deselectChildren(item);
    }

    return isNowSelected;
  }

  select(...items: NavigationItemEntity[]): void {
    items.forEach(item => {
      this.selectionForm.select(item.id);
      this.selectAncestors(item);
    });
  }

  selectAll(): void {
    this.select(...this.allItemsWithoutRoot);
  }

  getChanges(): ChangedItem<NavigationItemEntity>[] {
    return this.allItemsWithoutRoot
      .filter(({ id }) => this.selectionForm.hasChanged(id))
      .map(i => ({
        item: i,
        type: this.selectionForm.decideSelectionChangeType(i.id)
      }));
  }

  clear(): void {
    this.selectionForm.clear();
  }

  private get allItemsWithoutRoot(): NavigationItemEntity[] {
    const allItems = cloneDeep(this.egiApp.rootNavigationItem.asArray);
    allItems.unshift();
    return allItems;
  }

  private selectAncestors(item: NavigationItemEntity) {
    const ancestors = item.findAncestors(this.egiApp.rootNavigationItem);
    this.select(...ancestors);
  }

  private deselectChildren(i: NavigationItemEntity): void {
    i.forEachDescendant(child => this.selectionForm.deselect(child.id));
  }
}
